import styled, { keyframes } from 'styled-components';

interface IframeVideoPlayerProps {
  src: string;
  title?: string;
  type?: string;
  className?: string;
  onLoad?: () => void;
}

export function IframeVideoPlayer({
  src,
  title,
  type,
  className,
  onLoad
}: IframeVideoPlayerProps) {
  return (
    <IframeContainer className={className} _videoType={type}>
      <Iframe src={src} allow="autoplay" title={title} onLoad={onLoad} />
    </IframeContainer>
  );
}

const blinker = keyframes`
  from { opacity: 0.4; }
  to { opacity: 1; }
`;

const IframeContainer = styled.div<{
  _videoType?: string;
}>`
  height: 0;
  overflow: hidden;
  max-width: 100%;
  padding-bottom: ${({ _videoType }) =>
    _videoType === 'short_video' ? '156.25%' : '56.25%'};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgb(210, 210, 210);
    width: 100%;
    height: 100%;
    animation: ${blinker} 1.5s ease-in-out infinite alternate;
    opacity: 0.4;
  }
`;

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;
